import React from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

export default function InfoSection() {
  const cards = [
    {
      title: "Terms & Conditions",
      icon: <GavelOutlinedIcon fontSize="large" sx={{color:'#f35b04'}} />,
      text: "Read the rules and guidelines that define how our platform operates.",
    },
    {
      title: "Privacy Policy",
      icon: <LockOutlinedIcon fontSize="large" sx={{color:'#f35b04'}} />,
      text: "We ensure that your data is secure and never shared without consent.",
    },
    {
      title: "How We Work?",
      icon: <SettingsOutlinedIcon fontSize="large" sx={{color:'#f35b04'}} />,
      text: "Discover our transparent process and how we serve our members efficiently.",
    },
  ];

  return (
    <Box
      sx={{
        p: 5,
        backgroundColor: "#faf6f2",
        borderRadius: 3,
        textAlign: "center",
      }}
    >
      {/* Section Title */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color="#BF0603"
        fontFamily="quicksand"
        gutterBottom
      >
        Our Commitment to Transparency
      </Typography>

      {/* Cards */}
      <Grid container spacing={3} sx={{ mt: 5,justifyContent:'center' }}>
        {cards.map((card, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Card
              sx={{
                borderRadius: 3,
                width:'100%',
                maxWidth: '320px',
                p: 2,
                height: "100%",
                cursor:'pointer',
                transition: "0.3s",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                {card.icon}
              </Box>
              <CardContent>
                <Typography variant="h6" fontWeight="600" gutterBottom sx={{color:'#f35b04',fontFamily:"quicksand"}}>
                  {card.title}
                </Typography>
                <Typography variant="body2" sx={{color:'#000'}}>
                  {card.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
